export default "__VITE_ASSET__XlVVQhe1__"